export default __webpack_public_path__ + "src/images/packages/the-coconut-shell/7ee16c31ea7461367b2a6c899600f215-1.jpeg";